import React from "react";
import ReactDOM from "react-dom";

// Bootstrap must be imported before App so that App.css, which App imports,
// is injected afterwards and can override Bootstrap's defaults. With the order
// reversed, Bootstrap's link styling overrode the redesign's typography and the
// masthead rendered as a blue underlined link.
import "bootstrap/dist/css/bootstrap.rtl.min.css";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
